export enum QuoteFlowStepEnum {
  VehicleDetails = 0,
  UsageAndModifications = 1,
  SelectCoverage = 2,
  PaymentMethod = 3,
  ContactInfo = 4,
  SecondHolder = 5,
  Payment = 6,
  QuoteWrapUp = 7,
  VinAndMileage = 8,
  CoverageAvailability = 9,
  Closed = 10,
  SaleComplete = 11,
  SendQuote = 12,
  TransferCall = 13,
  Finalize = 14,
  Recap = 15,
  Equity = 16,
  ConfirmRewrite = 17,
  CompleteRewrite = 18,
}

export const QuoteFlowStepDisplayValues = {
  [QuoteFlowStepEnum.VehicleDetails]: 'Vehicle Details',
  [QuoteFlowStepEnum.UsageAndModifications]: 'Usage and Modifications',
  [QuoteFlowStepEnum.SelectCoverage]: 'Select Coverage',
  [QuoteFlowStepEnum.PaymentMethod]: 'Payment Method',
  [QuoteFlowStepEnum.ContactInfo]: 'Contact Info',
  [QuoteFlowStepEnum.SecondHolder]: 'Second Holder',
  [QuoteFlowStepEnum.Payment]: 'Payment',
  [QuoteFlowStepEnum.QuoteWrapUp]: 'Quote Wrap Up',
  [QuoteFlowStepEnum.VinAndMileage]: 'VIN and Mileage',
  [QuoteFlowStepEnum.CoverageAvailability]: 'Coverage Availability',
  [QuoteFlowStepEnum.Closed]: 'Closed',
  [QuoteFlowStepEnum.SaleComplete]: 'Sale Complete',
  [QuoteFlowStepEnum.SendQuote]: 'Send Quote',
  [QuoteFlowStepEnum.TransferCall]: 'Wrap Up',
  [QuoteFlowStepEnum.Finalize]: 'Finalize',
  [QuoteFlowStepEnum.Recap]: 'Recap',
  [QuoteFlowStepEnum.Equity]: 'Equity',
  [QuoteFlowStepEnum.ConfirmRewrite]: 'Confirm Rewrite',
  [QuoteFlowStepEnum.CompleteRewrite]: 'Complete Rewrite',
} satisfies Record<QuoteFlowStepEnum, string>;
